import { render, staticRenderFns } from "./ActPrintZbt.vue?vue&type=template&id=04a6189a&scoped=true"
import script from "./ActPrintZbt.vue?vue&type=script&lang=js"
export * from "./ActPrintZbt.vue?vue&type=script&lang=js"
import style0 from "./ActPrintZbt.vue?vue&type=style&index=0&id=04a6189a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04a6189a",
  null
  
)

export default component.exports